import { useMemo, useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';
import debounce from 'lodash/debounce';

import InputText from '@/design_system/InputText';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useUpdateArticle } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const PurchaseLocation = () => {
  const { t } = useLingui();
  const { request, article, view, errors } = useArticleContext();

  const [purchaseLocation, setPurchaseLocation] = useState(article.purchaseLocation ?? '');

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  const debouncedUpdateArticle = useMemo(() => {
    return debounce(updateArticle, 500);
  }, [updateArticle]);

  return (
    <InputText
      label={
        <>
          <Trans id="article.form.purchase-location.label">Purchase location</Trans>
          {!view.warranty.fields.purchaseLocation.required && <OptionalLabel />}
        </>
      }
      placeholder={t({
        id: 'article.form.purchase-location.placeholder',
        message: 'Add a purchase location',
      })}
      size="medium"
      value={purchaseLocation}
      onChange={(value) => {
        setPurchaseLocation(value);
        debouncedUpdateArticle({
          data: {
            purchaseLocation: value.trim() || null,
          },
        });
      }}
      error={
        errors.warranty?.missingPurchaseLocation
          ? t({
              id: 'article.form.purchase-location.error.missing',
              message: 'A purchase location is required',
            })
          : undefined
      }
      style={{ flex: 1 }}
    />
  );
};
